const DEFAULT_LINK = 'https://doi.org/'

/**
 * fullTextLink - Returns a link to the full text of a paper by checking whether we need to use a publisher specific url.
 * or default to doi.org.
 * @param paper - paper object to get DOI and memberID from.
 */
const fullTextLink = (paper) => {
  if (!paper?.memberId) {
    return `${DEFAULT_LINK}${paper?.doi}`
  }

  const publisherFullTextConfig = CONFIG.publisherFullTextLinkResolvers[paper?.memberId]
  if (!publisherFullTextConfig) {
    return `${DEFAULT_LINK}${paper?.doi}`
  }
  return `${publisherFullTextConfig.baseURL}?${publisherFullTextConfig.prefix}=${paper?.doi}&${publisherFullTextConfig.additionalParams}`
}
export default fullTextLink
